
import { useEffect } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import AreasServed from './components/AreasServed';
import LeadForm from './components/LeadForm';
import Contact from './components/Contact';
import About from './components/About';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

const SCHEMA_JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'HomeAndConstructionBusiness',
  name: 'Handyman of Stillwater',
  url: import.meta.env.VITE_SITE_URL ?? 'https://example.com',
  telephone: '+14057476904',
  description:
    'Professional handyman services in Stillwater, Enid, Ponca City, Guthrie, Perkins, Perry, Cushing, and Morrison, Oklahoma. Painting, plumbing, electrical, furniture assembly, TV mounting, home repair, appliance installation, moving help, and doors & windows.',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Stillwater',
    addressRegion: 'OK',
    addressCountry: 'US',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 36.1156,
    longitude: -97.0584,
  },
  areaServed: [
    { '@type': 'City', name: 'Stillwater', containedInPlace: { '@type': 'State', name: 'Oklahoma' } },
    { '@type': 'City', name: 'Enid', containedInPlace: { '@type': 'State', name: 'Oklahoma' } },
    { '@type': 'City', name: 'Ponca City', containedInPlace: { '@type': 'State', name: 'Oklahoma' } },
    { '@type': 'City', name: 'Guthrie', containedInPlace: { '@type': 'State', name: 'Oklahoma' } },
    { '@type': 'City', name: 'Perkins', containedInPlace: { '@type': 'State', name: 'Oklahoma' } },
    { '@type': 'City', name: 'Perry', containedInPlace: { '@type': 'State', name: 'Oklahoma' } },
    { '@type': 'City', name: 'Cushing', containedInPlace: { '@type': 'State', name: 'Oklahoma' } },
    { '@type': 'City', name: 'Morrison', containedInPlace: { '@type': 'State', name: 'Oklahoma' } },
  ],
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Handyman Services',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Painting' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Electrical Fixes' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Plumbing Fixes' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Furniture Assembly' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'TV Mounting' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'General Home Repair' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Appliance Installation' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Moving Help' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Doors & Windows' } },
    ],
  },
  priceRange: '$$',
};

export default function Home() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-home';
    script.textContent = JSON.stringify(SCHEMA_JSON_LD);
    document.head.appendChild(script);
    return () => {
      const existing = document.getElementById('schema-home');
      if (existing) existing.remove();
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <Services />
      <AreasServed />
      <LeadForm />
      <Contact />
      <About />
      <Footer />
    </div>
  );
}
